import React from "react";
import styled from "styled-components";

const constants = require("../constants");

const Wrapper = styled.div`
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  margin: ${(props) => props.wrapperPaddingMargin || 0};
  padding: ${(props) => props.wrapperPadding || 0};

  ${(props) => props.css || ""}
`;

const Title = styled.div`
  margin: ${(props) => props.titleMargin || "0"};
  font-size: ${(props) => props.size || "16px"};
  font-weight: ${(props) => props.fontWeight || 500};
  padding: ${(props) => props.padding || "0 28px"};
  height: ${(props) => props.height || "46px"};
  line-height: ${(props) => props.height || "46px"};
  background-color: ${(props) => (props.bg ? props.bg : "#fafafa")};
  color: ${(props) => (props.color ? props.color : "#5a5a5a")};
  text-align: ${(props) => props.align || "left"};
  @media only screen and (max-width: ${constants.breakpoints.lg}px) {
    padding: 0 16px;
  }

  ${(props) => props.css || ""}
`;

const Content = styled.div`
  padding: ${(props) => props.padding || "0 28px"};
  background-color: white;
  @media only screen and (max-width: ${constants.breakpoints.lg}px) {
    padding: 0 16px;
  }

  ${(props) => props.css || ""}
`;

const Block = ({ title, children, titleIcon, ...props }) => {
  return (
    <Wrapper {...props}>
      <Title {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {titleIcon}
          {title}
        </div>
      </Title>
      <Content {...props}>{children}</Content>
    </Wrapper>
  );
};

export default Block;
